import React from 'react';
import { Divider, Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/GeoViewV2/components/OwnershipDisclaimerSection/OwnershipDisclaimerSection.styles';
import { ImgBox } from 'views/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import Typography500 from 'views/common/components/UI/Typography500';

const OwnershipDisclaimerSection = () => {
  const cmsData = useContent('GeoPage');
  const erImage = {
    src:'/imgs/Rebranding/logos/er-logo-light.svg',
    alt: 'eagle-rider-logo',
  };
  const esImage = {
    src: '/imgs/Rebranding/logos/es-logo-light.svg',
    alt: 'eagle-share-logo',
  };

  
  return (
    <StyledBox>
      <Box className="ODSLogos" >
          <Box className="ODSERLogo">
            <ImgBox
              image={erImage}
              imgWidth="100%"
              imgHeight="36px"
              imgObjectFit="contain"
            />
          </Box>
           <Divider orientation="vertical" className='ODSDivider' />
           <Box className="ODSESLogo">
            <ImgBox
              image={esImage}
              imgWidth="100%"
              imgHeight="36px"
              imgObjectFit="contain"
            />
          </Box>
       
      </Box>
      <Typography500
        className="ODSText"
        variant="body1"
        component="p">
         {cmsData.erHoldingDescription}
      </Typography500>
    </StyledBox>
  );
};

export { OwnershipDisclaimerSection };
